import { z } from 'zod';
import { formDefinitionSection } from './form-definition-section.type';
import { FormCategory } from '../enums/form-category.enum';

const formDefinitionVisibility = z.object({
  hideDerivedForms: z.boolean(),
  roles: z.array(z.int()),
});

export const formDefinition = z.strictObject({
  id: z.int().positive().readonly().optional().meta({ maximum: undefined }),
  predecessorFormsDefinitionId: z.int().positive().nullable().meta({ maximum: undefined }),
  category: z.enum(FormCategory),
  name: z.string().trim().min(3),
  title: z.string().trim().min(3),
  creationDate: z.iso.datetime().meta({ pattern: undefined }),
  visibility: formDefinitionVisibility,
  sections: z.array(formDefinitionSection),
});
export const formDefinitions = z.array(formDefinition);

export type FormDefinition = z.infer<typeof formDefinition>;

type CamelToSnakeCase<S extends string> =
  S extends `${infer T}${infer U}` ? `${T extends Capitalize<T> ? '_' : ''}${Lowercase<T>}${CamelToSnakeCase<U>}` : S;

export type FormDefinitionDatabase = { [K in keyof FormDefinition as CamelToSnakeCase<K>]: FormDefinition[K] };
